
export const columnGap = {
  name: 'column-gap'
}

export const gap = {
  name: 'gap'
}

export const grid = {
  name: 'grid'
}

export const gridArea = {
  name: 'grid-area'
}

export const gridAutoColumns = {
  name: 'grid-auto-columns'
}

export const gridAutoFlow = {
  name: 'grid-auto-flow'
}

export const gridAutoRows = {
  name: 'grid-auto-rows'
}

export const gridColumn = {
  name: 'grid-column',
  unit: ''
}

export const gridColumnEnd = {
  name: 'grid-column-end',
  unit: ''
}

export const gridColumnGap = {
  name: 'grid-column-gap'
}

export const gridColumnStart = {
  name: 'grid-column-start',
  unit: ''
}

export const gridGap = {
  name: 'grid-gap'
}

export const gridRow = {
  name: 'grid-row',
  unit: ''
}

export const gridRowEnd = {
  name: 'grid-row-end',
  unit: ''
}

export const gridRowGap = {
  name: 'grid-row-gap'
}

export const gridRowStart = {
  name: 'grid-row-start',
  unit: ''
}

export const gridTemplate = {
  name: 'grid-template'
}

export const gridTemplateAreas = {
  name: 'grid-template-areas'
}

export const gridTemplateColumns = {
  name: 'grid-template-columns'
}

export const gridTemplateRows = {
  name: 'grid-template-rows'
}

export const rowGap = {
  name: 'row-gap'
}